import React from "react";

const IndiaIcon = ({ width = 20, height = 18 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id="indiaFlagClip">
          <circle cx="50" cy="50" r="44" />
        </clipPath>
      </defs>

      {/* Indian flag */}
      <g clipPath="url(#indiaFlagClip)">
        <rect x="0" y="5" width="100" height="30" fill="#FF9933" />
        <rect x="0" y="35" width="100" height="30" fill="#FFFFFF" />
        <rect x="0" y="65" width="100" height="30" fill="#138808" />

        {/* Ashoka Chakra */}
        <circle
          cx="50"
          cy="50"
          r="12"
          fill="none"
          stroke="#000080"
          strokeWidth="1.8"
        />

        {Array.from({ length: 24 }).map((_, i) => (
          <line
            key={i}
            x1="50"
            y1="50"
            x2="50"
            y2="38"
            stroke="#000080"
            strokeWidth="0.8"
            transform={`rotate(${i * 15} 50 50)`}
          />
        ))}

        <circle cx="50" cy="50" r="2" fill="#000080" />
      </g>

      {/* Circular border */}
      <circle
        cx="50"
        cy="50"
        r="45"
        fill="none"
        stroke="#3A3A3A"
        strokeWidth="2"
      />
    </svg>
  );
};

export default IndiaIcon;
